import login from './login.json';
import setPassword from './setPassword.json';
import forgotPassword from './forgotPassword.json';

export const auth = {
  login,
  setPassword,
  forgotPassword,
};
